export default "__VITE_ASSET__4UEvUhMV__"